import { render } from "./distribution_of_dealers.vue?vue&type=template&id=44f43c94&scoped=true"
import script from "./distribution_of_dealers.vue?vue&type=script&lang=js"
export * from "./distribution_of_dealers.vue?vue&type=script&lang=js"

import "./distribution_of_dealers.vue?vue&type=style&index=0&id=44f43c94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f43c94"]])

export default __exports__